<div class="container">

  <section class="instagram">
    <img id="cloud" class="cloud_left" src="../../../assets/img/clouds/cloud.svg" alt="image">
    <div class="instagram-container">
      <div class="instagram-header">
        <img src="../../../assets/img/icon/logo-instagram.svg" alt="icon">
        <div class="instagram-title">BusyFly в Instagram</div>
        <img src="../../../assets/img/icon/instagram-instagram.svg" alt="icon">
      </div>

      <div class="instagram-body">
        <div class="instagram-item">
          <div class="instagram-item-title">busyfly_gomel.by</div>
          <img class="instagram-image" src="../../../assets/img/instagram-item-img.png" alt="image">
        </div>
        <div class="instagram-item">
          <div class="instagram-item-title">busyfly_gelendzhik</div>
          <img class="instagram-image" src="../../../assets/img/instagram-item-img_1.png" alt="image">
        </div>

        <div class="instagram-item">
          <div class="instagram-item-title">busyfly_krsk</div>
          <img class="instagram-image" src="../../../assets/img/instagram-item-img_2.png" alt="image">
        </div>

        <div class="instagram-item">
          <div class="instagram-item-title">busy_fly.kaliningrad</div>
          <img class="instagram-image" src="../../../assets/img/instagram-item-img_3.png" alt="image">
        </div>
        <div class="instagram-item">
          <div class="instagram-item-title">busyfly.cheb</div>
          <img class="instagram-image" src="../../../assets/img/instagram-item-img_4.png" alt="image">
        </div>
        <div class="instagram-item">
          <div class="instagram-item-title">busyfly_dv</div>
          <img class="instagram-image" src="../../../assets/img/instagram-item-img_5.png" alt="image">
        </div>
        <div class="instagram-item">
          <div class="instagram-item-title">busyfly_volga</div>
          <img class="instagram-image" src="../../../assets/img/instagram-item-img_6.png" alt="image">
        </div>
        <div class="instagram-item">
          <div class="instagram-item-title">busyfly33</div>
          <img class="instagram-image" src="../../../assets/img/instagram-item-img_7.png" alt="image">
        </div>
        <div class="instagram-item">
          <div class="instagram-item-title">busyfly_orenburg</div>
          <img class="instagram-image" src="../../../assets/img/instagram-item-img_8.png" alt="image">
        </div>
      </div>
    </div>
  </section>
</div>
